import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import CaseStudySpotless from "@/pages/CaseStudySpotless";

export const Route = createFileRoute("/by/case-studies/spotless-polska")({
  head: () => routeHead("Кейс Spotless Polska — AGAPE", META_DESCRIPTIONS.spotless.by, "/by/case-studies/spotless-polska"),
  component: CaseStudySpotless,
});
